import { millsheetCsvColumnMapper } from '../millsheet/validateAndNormalizeMillsheetCsvRecords'
import { millsheetSubMaterialCsvColumnMapper } from '../millsheet/validateAndNormalizeMillsheetSubMaterialCsvRecords'

import type { MbgcMillsheet } from './mapMb2PermissionToMillsheet'

//
// MBGC ミルシートモデル(MbgcMillsheet) → 既存 CSV アップロードが受け付ける CSV 行への変換。
// MB2 には依存しない（ミルシートモデルさえあれば CSV 行を作れる）。
//

export type MillsheetCsvRow = Record<string, string>

// CSV の列順（既存アップロードが読む列）。
export const mb2RebarCsvHeaders: string[] = [
  millsheetCsvColumnMapper.manufacturerName,
  millsheetCsvColumnMapper.heatNumber,
  millsheetCsvColumnMapper.no,
  millsheetCsvColumnMapper.quantity,
  millsheetCsvColumnMapper.issuedDate,
  millsheetCsvColumnMapper.steelType,
  millsheetCsvColumnMapper.size,
  millsheetCsvColumnMapper.length,
  millsheetCsvColumnMapper.weight,
  millsheetCsvColumnMapper.constructionName,
  millsheetCsvColumnMapper.deliveryDestination,
  millsheetCsvColumnMapper.notificationNo,
]

export const mb2SubMaterialCsvHeaders: string[] = [
  millsheetSubMaterialCsvColumnMapper.manufacturerName,
  millsheetSubMaterialCsvColumnMapper.no,
  millsheetSubMaterialCsvColumnMapper.issuedDate,
  millsheetSubMaterialCsvColumnMapper.constructionName,
  millsheetSubMaterialCsvColumnMapper.deliveryDestination,
  millsheetSubMaterialCsvColumnMapper.productName,
  millsheetSubMaterialCsvColumnMapper.serialNumber,
  millsheetSubMaterialCsvColumnMapper.quantity,
  millsheetSubMaterialCsvColumnMapper.notificationNo,
]

// MB2 に対応カラムが無い項目（納入先・通知番号）は空のまま出力する。
const generateRebarCsvRows = (millsheet: Extract<MbgcMillsheet, { type: 'rebar' }>): MillsheetCsvRow[] =>
  millsheet.steels.map((steel) => ({
    [millsheetCsvColumnMapper.manufacturerName]: millsheet.manufacturerName,
    [millsheetCsvColumnMapper.heatNumber]: steel.heatNumber,
    [millsheetCsvColumnMapper.no]: millsheet.no,
    [millsheetCsvColumnMapper.quantity]: steel.quantity,
    [millsheetCsvColumnMapper.issuedDate]: millsheet.issuedDate,
    [millsheetCsvColumnMapper.steelType]: steel.steelType,
    [millsheetCsvColumnMapper.size]: steel.size,
    [millsheetCsvColumnMapper.length]: steel.length,
    [millsheetCsvColumnMapper.weight]: steel.weight,
    [millsheetCsvColumnMapper.constructionName]: millsheet.constructionName,
    [millsheetCsvColumnMapper.deliveryDestination]: '',
    [millsheetCsvColumnMapper.notificationNo]: '',
  }))

const generateSubMaterialCsvRows = (millsheet: Extract<MbgcMillsheet, { type: 'submaterial' }>): MillsheetCsvRow[] =>
  millsheet.subMaterials.map((subMaterial) => ({
    [millsheetSubMaterialCsvColumnMapper.manufacturerName]: millsheet.manufacturerName,
    [millsheetSubMaterialCsvColumnMapper.no]: millsheet.no,
    [millsheetSubMaterialCsvColumnMapper.issuedDate]: millsheet.issuedDate,
    [millsheetSubMaterialCsvColumnMapper.constructionName]: millsheet.constructionName,
    [millsheetSubMaterialCsvColumnMapper.deliveryDestination]: '',
    [millsheetSubMaterialCsvColumnMapper.productName]: subMaterial.productName,
    [millsheetSubMaterialCsvColumnMapper.serialNumber]: subMaterial.serialNumber,
    [millsheetSubMaterialCsvColumnMapper.quantity]: subMaterial.quantity,
    [millsheetSubMaterialCsvColumnMapper.notificationNo]: '',
  }))

/**
 * ミルシートモデルを、既存 CSV アップロード形式の行へ展開する（明細を 1 行ずつ）。
 * 種別はモデルの type で分岐する（payload からの種別判定は map 側で済んでいる）。
 */
export function generateMillsheetCsvRows(millsheet: MbgcMillsheet): MillsheetCsvRow[] {
  return millsheet.type === 'rebar' ? generateRebarCsvRows(millsheet) : generateSubMaterialCsvRows(millsheet)
}
